'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authAgent = undefined;
exports.default = openLoginPopup;
exports.getCenterCoordinates = getCenterCoordinates;

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.authAgent = new _events2.default();

var authAgent = exports.authAgent = window.authAgent;

/*
 * A helper template to that opens the provided URL in a centered popup.
 * Accepts an `options` object with `width` and `height` number properties.
 */
function openLoginPopup(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var width = options.width || 1024;
  var height = options.height || 640;

  var _getCenterCoordinates = getCenterCoordinates(window, width, height),
      top = _getCenterCoordinates.top,
      left = _getCenterCoordinates.left;

  var params = 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left;
  return window.open(url, 'authWindow', params);
}

/*
 * Returns the coordinates to center a popup window in the viewport with
 * the provided width and height args.
 */
function getCenterCoordinates(window, width, height) {
  return {
    left: window.screenX + (window.outerWidth - width) / 2,
    top: window.screenY + (window.outerHeight - height) / 2
  };
}